export default "__VITE_ASSET__Dz7d1jyR__"